import HomeHeader from "../components/home/HomeHeader";
import HomeVisual from "../components/home/HomeVisual";
import HomeInfo from "../components/home/HomeInfo";
import IntroOverlay from "../components/app/IntroOverlay";
import { useState } from "react";

export default function Home() {
	const [introFinished, setIntroFinished] = useState(false);

	return (
		<>
			<IntroOverlay onFinish={() => setIntroFinished(true)} />
			<div>
				<HomeHeader />
				<HomeVisual startSlides={introFinished} />
				<HomeInfo />
			</div>
		</>
	);
}